import { createAuthStore } from "@react/foundation/auth";

import { logger } from "../../../bootstrap/logger.ts";
import { STORE_KEY, STORE_VERSION } from "../../../bootstrap/store.ts";

export const { authSelectors, authStore, useAuthStore } = createAuthStore({
  logger,
  storeKey: STORE_KEY.auth,
  storeVersion: STORE_VERSION,
});
